import * as React from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import withStyles, { WithStylesProps } from 'react-jss';

import './styles.scss';

import Block from '../../Components/Block';
import Icon, { IconsAvailable } from '../../Components/Icon';
import {PropsWithChildren} from "react";

export interface ILayoutSidebarProps extends PropsWithChildren {
    /** Label for mobile sidebar opening button */
    openSidebarLabel: React.ReactNode;
    /** Mobile sidebar opening event */
    openSidebar: (event) => void;
    /** Icon for mobile sidebar opening button */
    openSidebarIcon?: IconsAvailable;
    /** AddOn text for mobile sidebar opening button */
    openSidebarAddOn?: React.ReactNode;
    /** Layouts to choose from */
    layout?: 'default';
    /** className to append */
    className?: string;
}

interface IState {
}

type Props = ILayoutSidebarProps & WithStylesProps<typeof styles>;

/**
 * Basic details wrapper.
 */
class LayoutSidebar extends React.Component<Props, IState> {
    static displayName: string = 'LayoutSidebar';

    render () {
        return (
            <Block
                innerClassName={classNames('layout-sidebar', {
                    'layout-sidebar-default': this.props.layout === 'default' || !this.props.layout,
                }, this.props.className)}
            >
                <div className="layout-sidebar-button">
                    <button onClick={this.props.openSidebar}>
                        <div className="inner">
                            {this.props.openSidebarIcon && (
                                <Icon width={16} height={16} kind={this.props.openSidebarIcon}/>
                            )}
                            <div className="text">{this.props.openSidebarLabel}</div>
                            {this.props.openSidebarAddOn && (
                                <div className={classNames('addon', this.props.classes.addon)}>{this.props.openSidebarAddOn}</div>
                            )}
                        </div>
                    </button>
                </div>
                {this.props.children}
            </Block>
        );
    }
}

const styles = (theme) => {
    return {
        addon: {
            color: theme.colors.sum || theme.colors.primary,
        },
    };
};

export default compose<React.ComponentClass<ILayoutSidebarProps>>(
    withStyles(styles, { injectTheme: true })
)(LayoutSidebar);
